const NAME = "ALLERGIES_EXAMS_DISEASES";

export default NAME;
